/**
 * 数値を安全にパースする共通関数
 * @param {any} value - パースする値
 * @param {number} defaultValue - パースに失敗した場合のデフォルト値
 * @returns {number} - パースした数値
 */
export const safeParseFloat = (value, defaultValue = 0) => {
    if (value === null || value === undefined || value === '') {
        return defaultValue;
    }

    try {
        const numericValue = parseFloat(value);
        return isNaN(numericValue) ? defaultValue : numericValue;
    } catch (error) {
        console.error('数値パースエラー:', error, value);
        return defaultValue;
    }
};

/**
 * 整数を安全にパースする共通関数
 * @param {any} value - パースする値
 * @param {number} defaultValue - パースに失敗した場合のデフォルト値
 * @returns {number} - パースした整数
 */
export const safeParseInt = (value, defaultValue = 0) => {
    if (value === null || value === undefined || value === '') {
        return defaultValue;
    }

    try {
        const numericValue = parseInt(value, 10);
        return isNaN(numericValue) ? defaultValue : numericValue;
    } catch (error) {
        console.error('整数パースエラー:', error, value);
        return defaultValue;
    }
}; 